<script>
import api from '@/api'
import { alertError } from '@/helpers/swal'
import pagination from '@/components/pagination.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { convertDateFromGMTToLocal } from '@/helpers/date'

export default {
  data() {
    return {
      loading: true,
      pagetitle: 'Cleared Alerts',
      alerts: [],
      totalItems: 0,
      totalPages: 1,
      currentPage: 0,
      perPage: 50,
      baseUrl: `${window.apiUrl}/alerts/cleared`,
      exportMonths: [],
      selectedMonth: '',
      exportBtnDisabled: false,
      searchHost: '',
      components: [
        { name: 'Device', value: 'monitoring_alert' },
        { name: 'Memory', value: 'memory_alerts' },
        { name: 'Memory EZELINK', value: 'memory_alerts_collectd' },
        { name: 'Disk', value: 'disk_alerts' },
        { name: 'Disk EZELINK', value: 'disk_alerts_collectd' },
        { name: 'CPU', value: 'cpu_alerts' },
        { name: 'CPU EZELINK', value: 'cpu_alerts_collectd' },
        { name: 'Interface', value: 'interface_alerts'},
        { name: 'Web Service', value: 'web_service_alert'},
        { name: 'Database Service', value: 'database_service_alert'},
        { name: 'Monitoring Service', value: 'monitoring_service_alert'},
        { name: 'Cache Service', value: 'cache_service_alert'},
        { name: 'Zero User', value: 'zero_user_alert'},
        { name: 'License Utilization', value: 'license_utilization_alert' },
        { name: 'Sync Status', value: 'sync_status_alert' },
        { name: 'HA Status', value: 'ha_status_alert' },
      ],
      alertLevels: ['Critical', 'Warning'],
      categories: [],
      filters: {
        measurement: null,
        alertLevelCurrent: null,
        category: null,
      },
      sortBy: 'id',
      sortDir: 'desc',
      columns: [
        { name: 'time', label: 'Time', sortable: true },
        { name: 'measurement', label: 'Component', sortable: false },
        { name: 'agentHost', label: 'Device', sortable: true },
        { name: 'alertLevelCurrent', label: 'Level', sortable: false },
        { name: 'alertMessage', label: 'Message', sortable: false },
        { name: 'category', label: 'Category', sortable: false },
      ],
    }
  },
  components: {
    pagination,
    vSelect,
  },
  async mounted() {
    await this.getCategories()

    this.filters = {
      measurement: this.measurement || null,
      alertLevelCurrent: this.alertLevelCurrent || null,
      category: this.category || null,
    }

    this.refreshInterval = setInterval(() => {
      this.applyFilters();
    }, 60000);
  },
  unmounted(){
    if(this.refreshInterval) {
        clearInterval(this.refreshInterval);
    }
  },
  watch: {
    filters: {
      handler() {
        this.applyFilters()
      },
      deep: true,
    },
  },
  methods: {
    convertDateFromGMTToLocal,
    async getCategories() {
      await api
        .get(`${window.apiUrl}/category/getCategories`)
        .then((response) => {
          this.categories = response.data || []
        })
        .finally(() => {
          this.loading = false
        })
    },

    async getAlerts() {
      this.loading = true
      const params = {
        page: this.currentPage,
        size: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
        measurement: this.filters.measurement,
        alertLevelCurrent: this.filters.alertLevelCurrent,
        category: this.filters.category,
      }
      if (this.searchHost) {
        params.agentHost = this.searchHost
      }
      await api
        .get(this.baseUrl, { params })
        .then((response) => {
          this.alerts = response.data?.alerts || []
          this.totalItems = response.data.totalItems
          this.totalPages = response.data.totalPages
          this.currentPage = response.data.currentPage

          this.createMonthList(response.data.oldestRecordDate)
        })
        .finally(() => {
          this.loading = false
        })
    },

    applyFilters() {
      this.currentPage = 0
      this.getAlerts()
    },

    sortByColumn(column) {
      if (column.sortable) {
        this.sortBy = column.name
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
        this.currentPage = 0
        this.getAlerts()
      }
    },

    updatePage(newPage) {
      this.currentPage = newPage - 1
      this.getAlerts()
    },

    alertType(measurement) {
      let type = ''
      if (measurement === 'monitoring_alert') {
        type = 'Device'
      } else if (measurement === 'memory_alerts' || measurement === 'memory_alerts_collectd') {
        type = 'Memory'
      } else if (measurement === 'disk_alerts' || measurement === 'disk_alerts_collectd') {
        type = 'Disk'
      } else if (measurement === 'cpu_alerts' || measurement === 'cpu_alerts_collectd') {
        type = 'CPU'
      } else if (measurement === 'interface_alerts') {
        type = 'Interface'
      } else if (measurement === 'interface_error_alert') {
        type = 'Interface Error'
      } else if (measurement === 'zero_user_alert') {
        type = 'Zero User'
      } else if (measurement === 'web_service_alert') {
        type = 'Web Service'
      } else if (measurement === 'database_service_alert') {
        type = 'Database Service'
      } else if (measurement === 'monitoring_service_alert') {
        type = 'Monitoring Service'
      } else if (measurement === 'cache_service_alert') {
        type = 'Cache Service'
      } else if (measurement === 'license_utilization_alert') {
        type = 'License Utilization'
      } else if (measurement === 'sync_status_alert') {
        type = 'Sync Status'
      } else if (measurement === 'ha_status_alert') {
        type = 'HA Status'
      }
      return type
    },

    createMonthList(date) {
      this.exportMonths = []

      const start = new Date(date.replace(' ', 'T'))
      const end = new Date()

      start.setDate(1)
      end.setDate(1)

      const months = []
      const cursor = new Date(end)

      while (cursor >= start) {
        const value = `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, '0')}`
        months.push(value)
        cursor.setMonth(cursor.getMonth() - 1)
      }

      this.exportMonths = months
      this.selectedMonth = this.exportMonths[0] // "YYYY-MM"
    },
    formatMonthLabel(month) {
      const [year, monthIndex] = month.split('-')
      const date = new Date(year, monthIndex - 1, 1)

      return date.toLocaleString('default', {
        month: 'long',
        year: 'numeric',
      })
    },

    exportData() {
      if (!this.alerts.length) {
        alertError('There is no data to export')
        return
      }

      this.exportBtnDisabled = true

      const date = new Date(this.selectedMonth)
      const month = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`

      let params = {
        month: month,
      }
      api
        .get('/alerts/cleared/export', { params })
        .then((response) => {
          let csvString = response.data
          this.exportCSVStringToFile('Cleared Alerts.csv', csvString)
        })
        .finally(() => {
          this.exportBtnDisabled = false
        })
    },

    exportCSVStringToFile(filename, csvString) {
      const blob = new Blob(['\uFEFF' + csvString], { type: 'text/csv;charset=utf-8;' }) // Add BOM for Excel compatibility
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row g-3 align-items-center">
            <div class="col-lg-9">
              <div class="row g-2">
                <div class="col-sm-6 col-md-3">
                  <form @submit.prevent="applyFilters()">
                    <div class="input-group">
                      <input type="search" class="form-control" placeholder="Device" v-model="searchHost" />
                      <span class="input-group-text cursor-pointer" @click="applyFilters()">
                        <i class="bx bx-search"></i>
                      </span>
                    </div>
                  </form>
                </div>
                <div class="col-sm-6 col-md-3">
                  <v-select id="component-input" v-model="filters.measurement" :options="components" label="name" placeholder="Component" :reduce="(component) => component.value">
                    <template #open-indicator="{ attributes, isOpen }">
                      <i class="font-size-22 fw-semibold bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'" v-bind="attributes"></i>
                    </template>
                  </v-select>
                </div>
                <div class="col-sm-6 col-md-3">
                  <v-select id="level-input" v-model="filters.alertLevelCurrent" :options="alertLevels" placeholder="Level">
                    <template #open-indicator="{ attributes, isOpen }">
                      <i class="font-size-22 fw-semibold bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'" v-bind="attributes"></i>
                    </template>
                  </v-select>
                </div>
                <div class="col-sm-6 col-md-3">
                  <v-select id="category-input" v-model="filters.category" :options="categories" label="categoryName" placeholder="Category" :reduce="(category) => category.categoryName">
                    <template #open-indicator="{ attributes, isOpen }">
                      <i class="font-size-22 fw-semibold bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'" v-bind="attributes"></i>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="d-flex justify-content-lg-end">
                <button
                  v-if="authUserHasPermission('cleared_alerts_export')"
                  class="btn btn-light d-flex align-items-center gap-1"
                  :disabled="exportBtnDisabled"
                  data-bs-toggle="modal"
                  data-bs-target="#exportModal"
                >
                  <i v-if="exportBtnDisabled" class="bx bx-loader bx-spin"></i>
                  <i v-else class="bx bx-export"></i>
                  Export
                </button>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th v-for="(column, columnIndex) in columns" :key="columnIndex" @click="sortByColumn(column)" :class="column.sortable ? 'cursor-pointer' : ''">
                        <div class="d-flex align-itmes-center justify-content-between">
                          <span>{{ column.label }}</span>
                          <i v-if="sortBy === column.name" :class="'bx bx-sort-' + (sortDir === 'asc' ? 'up' : 'down') + ' font-size-20'"></i>
                          <i v-else-if="column.sortable" class="bx bx-sort font-size-20"></i>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n">
                        <td v-for="m in 6" :key="m" class="placeholder-glow">
                          <span class="placeholder col-12"></span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="alerts.length">
                      <tr v-for="(alert, alertIndex) in alerts" :key="alertIndex">
                        <td>{{ convertDateFromGMTToLocal(alert.time) }}</td>
                        <td>{{ alertType(alert.measurement) }}</td>
                        <td class="text-uppercase">{{ alert.agentHost }}</td>
                        <td>
                          <span v-if="alert.alertLevelCurrent.toLowerCase() === 'critical'" class="badge badge-alert bg-danger text-uppercase">
                            <i class="mdi mdi-alert-rhombus"></i>
                            critical
                          </span>
                          <span v-else-if="alert.alertLevelCurrent.toLowerCase() === 'warning' || alert.alertLevelCurrent.toLowerCase() === 'trouble'" class="badge badge-alert bg-warning text-uppercase">
                            <i class="mdi mdi-alert-circle"></i>
                            warning
                          </span>
                          <span v-else-if="alert.alertLevelCurrent.toLowerCase() === 'ok' || alert.alertLevelCurrent.toLowerCase() === 'normal'" class="badge badge-alert bg-success text-uppercase">
                            <i class="mdi mdi-check-circle"></i>
                            ok
                          </span>
                        </td>
                        <td>{{ alert.alertMessage }}</td>
                        <td>{{ alert.category }}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="6" class="text-center">No alerts found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div v-if="!loading && alerts.length" class="card-footer">
          <pagination :baseUrl="baseUrl" :totalItems="totalItems" :perPage="perPage" :currentPage="currentPage + 1" @page-changed="updatePage" />
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="exportModal" tabindex="-1" role="dialog" aria-labelledby="exportModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header justify-content-center">
          <h5 class="modal-title" id="exportModalLabel">Export Cleared Alerts</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="exportData()">
            <div class="form-floating form-floating-custom mb-4">
              <select class="form-select" id="select-month" v-model="selectedMonth">
                <option v-for="(month, index) in exportMonths" :key="index" :value="month">{{ formatMonthLabel(month) }}</option>
              </select>
              <label for="select-month">Month</label>
              <div class="form-floating-icon">
                <eva-icon name="calendar-outline"></eva-icon>
              </div>
            </div>
            <div class="mb-3">
              <button class="btn btn-primary w-100 waves-effect waves-light position-relative" @click.prevent="exportData()" :disabled="exportBtnDisabled">
                Export
                <i v-show="exportBtnDisabled" class="mdi mdi-spin mdi-loading position-absolute end-0 me-3"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
